import createRouter from 'router5';
import loggerPlugin from 'router5-plugin-logger';
import browserPlugin from 'router5-plugin-browser';
import { getSegmentActionResult } from './dependencies/get-segment-action-result';
import { getRouteActionResult } from './dependencies/get-route-action-result';
import { actionHandler } from './middlewares/action-handler';
import { restoreScrollPosition } from './plugins/restore-scroll-position';
import { cancelRequestPlugin } from './plugins/cancel-request-plugin';
import { setMeta } from './plugins/set-meta';
import { i18nextLoader } from './middlewares/i18next-loader';
import { redirectToNotFoundPlugin } from './plugins/redirect-to-not-found';
import { stopLoadingsPlugin } from './plugins/stop-loadings-plugin';
import { isClient } from './utils/is-client';
import { cloneRoutes } from './utils/clone-routes';
import { deactivationHandler } from './middlewares/deactivation-handler';
import withNavigation from './utils/navigation';
var isDev = process.env.NODE_ENV === 'development';
export var configureRouter = function (_a) {
    var defaultRoute = _a.defaultRoute, eventNameToCancelRequests = _a.eventNameToCancelRequests, enablei18nMiddleware = _a.enablei18nMiddleware, enableDeactivationMiddleware = _a.enableDeactivationMiddleware, customi18nPlugin = _a.customi18nPlugin, disabledActionHandler = _a.disabledActionHandler, customActionHandler = _a.customActionHandler, _b = _a.routes, routes = _b === void 0 ? [] : _b, setMetaPlugin = _a.setMetaPlugin, _c = _a.allowNotFound, allowNotFound = _c === void 0 ? false : _c, modifiedNavigation = _a.modifiedNavigation, _d = _a.queryParamsMode, queryParamsMode = _d === void 0 ? 'loose' : _d;
    var isNode = !isClient();
    var initRoutes = isNode ? cloneRoutes(routes) : routes;
    var router = createRouter(initRoutes, {
        defaultRoute: defaultRoute,
        defaultParams: {},
        allowNotFound: allowNotFound,
        caseSensitive: true,
        queryParamsMode: queryParamsMode,
    });
    if (modifiedNavigation) {
        // replace default naigate method with upgraded
        withNavigation(router);
    }
    // Dependencies
    router.setDependencies({
        routerId: +new Date(),
        routes: routes,
        getSegmentActionResult: getSegmentActionResult(router),
        getRouteActionResult: getRouteActionResult(router),
    });
    if (enablei18nMiddleware) {
        var i18nextPlugin = customi18nPlugin || i18nextLoader;
        router.useMiddleware(i18nextPlugin);
    }
    if (!disabledActionHandler) {
        var usedActionHandler = customActionHandler || actionHandler;
        router.useMiddleware(usedActionHandler);
    }
    if (enableDeactivationMiddleware) {
        router.useMiddleware(deactivationHandler);
    }
    // Plugins
    if (!isNode) {
        router.usePlugin(browserPlugin());
    }
    router.usePlugin(redirectToNotFoundPlugin);
    if (isNode) {
        return router;
    }
    // eslint-disable-next-line
    // @ts-ignore
    router.usePlugin(stopLoadingsPlugin);
    var usedSetMetaPlugin = setMetaPlugin || setMeta;
    router.usePlugin(usedSetMetaPlugin);
    if (eventNameToCancelRequests) {
        router.usePlugin(cancelRequestPlugin(eventNameToCancelRequests));
    }
    if (isDev) {
        router.usePlugin(loggerPlugin);
    }
    router.usePlugin(restoreScrollPosition);
    return router;
};
